module.exports = __webpack_public_path__ + "img/1205.8c0c9240.jpg";